import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "datalist"]
  static values = { url: String }

  connect() {
    this.timeout = null
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  search() {
    clearTimeout(this.timeout)
    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this.clearOptions()
      return
    }

    this.timeout = setTimeout(() => this.fetchOptions(query), 300)
  }

  async fetchOptions(query) {
    const url = `${this.urlValue}?q=${encodeURIComponent(query)}`

    this.inputTarget.classList.add("opacity-70")
    try {
      const response = await fetch(url)
      const json = await response.json()
      this.renderOptions(json.data)
    } catch {
      this.clearOptions()
    } finally {
      this.inputTarget.classList.remove("opacity-70")
    }
  }

  renderOptions(names) {
    this.datalistTarget.innerHTML = names
      .map((name) => `<option value="${this.escapeHtml(name)}">`)
      .join("")
  }

  clearOptions() {
    this.datalistTarget.innerHTML = ""
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
